import get from 'lodash/get.js';

import Model from '@/models/Model.js';

export default class MeetingRecording extends Model {
    static entity = 'meeting_recordings';

    static fields() {
        return {
            id: this.attr(null),
            meeting_id: this.attr(null),
            recordable_type: this.attr(null),
            recordable_type_table: this.attr(null),
            recordable_id: this.attr(null),
            type: this.attr(null),
            content: this.attr(null),
            is_hidden: this.boolean(false),
            transcript_for_video_id: this.attr(null),
            recording_visibility: this.boolean(null),

            ...super.fields(),

            meeting: this.belongsTo('meetings', 'meeting_id'),
            recordable: this.morphTo('recordable_id', 'recordable_type_table'),
        };
    }

    get is_video() {
        return this.type === 'video';
    }

    get is_chat() {
        return this.type === 'chat';
    }

    get is_transcript() {
        return this.type === 'transcript';
    }

    get video_is_valid() {
        return !!get(this.recordable, 'processed_at');
    }
}
